import { Button, Layout, theme, Form, Input, Spin, notification, DatePicker } from "antd";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import RuntimeConfigsApi from "../../common/Apis/RuntimeConfigsApi";

const AddTwilioConfigurations = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    const activeFromN = convertToUnixTimestamp(data.activeFrom);
    const activeToN = convertToUnixTimestamp(data.activeTo);
    let formData = JSON.stringify({
      configValue: data?.configValue,
      configKey: data?.configKey,
      tag: data?.tag,
      activeFrom: activeFromN,
      activeTo: activeToN,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    })

    RuntimeConfigsApi.CreateRuntimeConfigs(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/settings/twilio-configurations");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };
  
    function convertToUnixTimestamp(dateValue) {
    if (!dateValue) return null;

    if (typeof dateValue === "string") {
      const parts = dateValue.split("/");
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);

      return Date.UTC(year, month, day);
    }

    return dateValue.startOf("day").valueOf();
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>  <Col lg={10} md={12}>
                <Form.Item
                  name="configKey"
                  label="Config Key"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Config Key",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Config Key"
                    className="control-input"
                  />
                </Form.Item>
              </Col>
                <Col lg={10} md={12}>
                  <Form.Item
                    name="configValue"
                    label="Config Value"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Config Value",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Config Value"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

                <Col lg={10} md={12}>
                  <Form.Item
                    name="activeFrom"
                    label="Active From"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Active From",
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      placeholder="Select Active From"
                      className="form-control control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={10} md={12}>
                  <Form.Item
                    name="activeTo"
                    label="Active To"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Active To",
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      placeholder="Select Active To"
                      className="form-control control-input"
                    />
                  </Form.Item>
                </Col> <Col lg={10} md={12}>
                  <Form.Item
                    name="tag"
                    label="Tag"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Tag",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Tag "
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

              </Row>


              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout >
  );
};
export default AddTwilioConfigurations;
